import { READ_ACTION, COPILOT_AUDIT } from '@/constants/resources'

export default [
  {
    path: '/copiloto/auditoria',
    name: 'copilot-audit',
    component: () => import('@/modules/copilot_audit/views/CopilotAuditList.vue'),
    meta: {
      resource: COPILOT_AUDIT,
      action: READ_ACTION,
      pageTitle: 'Auditoria do Copiloto',
    },
  },
]
